import React from 'react'
import { Filter, TextInput } from 'react-admin'
import { makeStyles } from '@material-ui/core'
import { capitalize } from '@obvious.tech/util/string'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
  },
}))

const CustomFilter = ({ entity, name, microservice, ...props }) => {
  const classes = useStyles()
  const filters = Object.keys(entity.properties)
    .filter(propertyKey => {
      const property = entity.properties[propertyKey]

      if (property.hidden) return false

      switch (property.type) {
        case 'string':
          return true
        case 'array':
          return property?.items?.type === 'string'
        case 'groups':
          return true
        default:
          return false
      }
    })
    .map(propertyKey => {
      return (
        <TextInput
          label={capitalize(propertyKey)}
          key={propertyKey}
          source={propertyKey}
        />
      )
    })

  return (
    <Filter
      className={classes.root}
      key='filter'
      {...props}
    >
      <TextInput
        key='simple_search'
        label='Search'
        source='q'
        alwaysOn
      />
      {filters}
    </Filter>
  )
}
export default CustomFilter
